import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/manhwa";

export default function Navbar() {
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 max-w-screen-2xl mx-auto">
          <Link
            to="/"
            className="flex items-center gap-2 text-foreground-900 hover:text-primary-600 transition-colors duration-200"
          >
            <span className="text-2xl font-black tracking-tight font-serif">
              <span className="text-primary-500">韩漫</span>大全
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                location.pathname === "/"
                  ? "bg-primary-100 text-primary-700"
                  : "text-foreground-600 hover:text-foreground-900 hover:bg-background-100"
              }`}
            >
              首页
            </Link>
            {categories.slice(0, 6).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                  location.pathname.includes(`/category/${cat.slug}`)
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-600 hover:text-foreground-900 hover:bg-background-100"
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                location.pathname === "/about"
                  ? "bg-primary-100 text-primary-700"
                  : "text-foreground-600 hover:text-foreground-900 hover:bg-background-100"
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors"
            aria-label="菜单"
          >
            <i className={`ri-${isMobileOpen ? "close" : "menu"}-line text-xl`} />
          </button>
        </div>
      </nav>

      {isMobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 shadow-lg">
          <div className="px-4 py-3 flex flex-col gap-1">
            <Link
              to="/"
              className={`px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 ${
                location.pathname === "/"
                  ? "bg-primary-100 text-primary-700"
                  : "text-foreground-600 hover:bg-background-100"
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 ${
                  location.pathname.includes(`/category/${cat.slug}`)
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-600 hover:bg-background-100"
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 ${
                location.pathname === "/about"
                  ? "bg-primary-100 text-primary-700"
                  : "text-foreground-600 hover:bg-background-100"
              }`}
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}